var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5143 1.04199C30.4545 1.04199 31.3562 1.41548 32.021 2.0803C32.6858 2.74512 33.0593 3.6468 33.0593 4.587V29.402C33.0593 30.3422 32.6858 31.2439 32.021 31.9087C31.3562 32.5735 30.4545 32.947 29.5143 32.947H4.6993C3.75911 32.947 2.85742 32.5735 2.1926 31.9087C1.52779 31.2439 1.1543 30.3422 1.1543 29.402V4.587C1.1543 3.6468 1.52779 2.74512 2.1926 2.0803C2.85742 1.41548 3.75911 1.04199 4.6993 1.04199H29.5143ZM28.6281 28.5158V19.1215C28.6281 17.589 28.0193 16.1192 26.9356 15.0356C25.852 13.9519 24.3822 13.3432 22.8497 13.3432C21.3431 13.3432 19.5883 14.2649 18.7375 15.6474V13.6799H13.7922V28.5158H18.7375V19.7773C18.7375 18.4125 19.8365 17.2958 21.2013 17.2958C21.8594 17.2958 22.4906 17.5573 22.956 18.0226C23.4213 18.488 23.6828 19.1192 23.6828 19.7773V28.5158H28.6281ZM8.0316 10.8971C8.82136 10.8971 9.57878 10.5834 10.1372 10.0249C10.6957 9.46648 11.0094 8.70906 11.0094 7.9193C11.0094 6.27087 9.68003 4.92377 8.0316 4.92377C7.23714 4.92377 6.47521 5.23937 5.91344 5.80114C5.35167 6.36291 5.03608 7.12484 5.03608 7.9193C5.03608 9.56772 6.38318 10.8971 8.0316 10.8971ZM10.4954 28.5158V13.6799H5.58555V28.5158H10.4954Z",
    fill: "#0E8080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7231,
    height: 32.7231,
    fill: "white",
    transform: "translate(0.746094 0.633789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.3d266c1ae449867f94715d33bf20ab5d.svg";
export { ForwardRef as ReactComponent };